import React from "react";
import { TQuoteRateCreatedOverlappingForm } from "../../../../../domain/codecs/form/QuoteRateForm";
import { useHover } from "../../../hooks/useHover";
import { CRMColors } from "../../../models/CRMColors";
import { CRMSpacing } from "../../../models/CRMSpacing";
import { Background } from "../../BuildingBlocks/Background";
import { SpacingColumn } from "../../BuildingBlocks/SpacingColumn";
import { SpacingRow } from "../../BuildingBlocks/SpacingRow";
import { CRMIcon } from "../../CRMIcon/CRMIcon";
import { CRMQuoteRateCardDetailOverlapping } from "../CRMQuoteRateCardDetail/CRMQuoteRateCardDetailOverlapping";

export const CRMCreatedQuoteRateCardOverlapping = (props: React.PropsWithChildren<{
    form: TQuoteRateCreatedOverlappingForm,
}>): JSX.Element => {
    const [ref, isHovering] = useHover<HTMLDivElement>({});

    return <Background
        divRef={ref}
        borderRadius="3px"
        color={CRMColors.NEUTRAL_PAPER}
    >
        <SpacingColumn spacing={CRMSpacing.MEDIUM}>
            <SpacingRow
                spacing={CRMSpacing.SMALL}
                justifyContent="start"
                alignItems="center"
            >
                {/* BULLET ICON */}
                <CRMIcon
                    iconName="reply-reverse"
                    size="small"
                    colour="neutral-ink"
                />

                {/* TYPE ICON */}
                <Background
                    borderRadius="5px"
                    color={CRMColors.NEUTRAL_10}
                    padding={CRMSpacing.TINY}
                >
                    <CRMIcon
                        iconName="add"
                        size="extra-medium"
                        colour="neutral-4"
                    />
                </Background>

                {/* DETAIL */}
                <CRMQuoteRateCardDetailOverlapping
                    form={props.form.original}
                />
            </SpacingRow>
        </SpacingColumn>
    </Background>;
}
